import React, { createContext, useState } from "react";

import { groupShirtAreas, isCloseToWhite } from "../helpers";
import {
  PRODUCT_IDS,
  PRODUCT_VALUES,
  PRODUCTS,
  SHIRT_PARTS,
} from "../constants";

export const ShirtAreaContext = createContext({
  isWrongFormat: false,
  areas: null,
  fees: null,
  printType: {
    isEmbroidery: true,
    isPrint: true,
  },
  locationImages: [],
  groupedPositions: {},
  terms: null,
  selectedProUrl: null,
  isWhite: false,
  isDisabled: false,
  category: null,
  getAreas: () => {},
});

export function ShirtAreaProvider({ children }) {
  const [isWrongFormat, setIsWrongFormat] = useState(false);
  const [areas, setAreas] = useState(null);
  const [groupedPositions, setGroupedPositions] = useState({});
  const [printType, setPrintType] = useState({
    isEmbroidery: true,
    isPrint: true,
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const [terms, setTerms] = useState(null);
  const [selectedProUrl, setSelectedProUrl] = useState(null);
  const [locationImages, setLocationImages] = useState([]);
  const [isWhite, setIsWhite] = useState(false);
  const [category, setCategory] = useState(null);
  const [fees, setFees] = useState(null);

  // const getDivData = () => {
  //   const divData = document
  //     .getElementById("react-popup-container")
  //     .getAttribute("data-json");

  //   return divData !== "NULL" ? JSON.parse(divData) : null;
  // };

  const getAreas = (data = null) => {
    if (data) {
      let isValid = true;

      // for (const key in data) {
      //   const value = data[key];
      //   if (value?.box_dimension) {
      //     if (!PRODUCT_VALUES.includes(value?.box_dimension?.width)) {
      //       isValid = false;
      //       break;
      //     }
      //   }
      // }

      // if (
      //   !PRODUCTS.includes(data?.product_category) ||
      //   !isValid ||
      //   !PRODUCT_IDS.includes(data?.product_id)
      // ) {
      //   setIsWrongFormat(true);
      // }
      setAreas(data);
      getGroupedPositions(data?.shirt_areas);
      setFees(data?.fees);
      setPrintType({
        isEmbroidery: data?.embroidery === "1",
        isPrint: data?.print === "1",
      });
      setIsDisabled(data?.add_logo !== "1");
      setTerms(
        data?.termcondition || '<label style="color: red">Not Found</label>',
      );
      setSelectedProUrl(data?.main_shirt_url);

      setLocationImages(data?.position_image);
      setCategory(data?.product_category);
      setIsWhite(isCloseToWhite(data?.selected_color));
    } else {
      const errorDiv = document.getElementById("color-react-error");
      if (errorDiv) {
        errorDiv.innerText = "Select a colour first";
        errorDiv.style.color = "red";
      }
    }
  };

  const getGroupedPositions = (shirt_areas = []) => {
    setGroupedPositions(groupShirtAreas(shirt_areas));
  };

  return (
    <ShirtAreaContext.Provider
      value={{
        areas,
        fees,
        printType,
        locationImages,
        groupedPositions,
        terms,
        selectedProUrl,
        isWhite,
        isDisabled,
        category,
        getAreas,
        isWrongFormat,
      }}
    >
      {children}
    </ShirtAreaContext.Provider>
  );
}
